import { GMedication } from '../../store/db';
import {
    FamilyHistory,
    MHFrequency,
    MHItem2,
    MHSince,
    PastProcedures,
} from '../../store/types/medicalHistory';

export const getMedicationsProperties = (element: GMedication) => {
    const properties = [
        element?.dose?.value
            ? `Dose: ${element.dose.value} ${element.dose.unit}`
            // @ts-expect-error ts version upgrade
            : '' || element?.dose?.custom
            ? `Dose: ${element?.dose?.custom}`
            : '',
        element?.area?.name ? `Site Of Application: ${element.area.name}` : '',
        element.frequency?.custom
            ? `Frequency: ${element.frequency?.custom}`
            // @ts-expect-error ts version upgrade
            : '' || element.frequency?.code
            ? `Frequency: ${element.frequency?.code}`
            // @ts-expect-error ts version upgrade
            : '' || (element.frequency?.onceEvery?.value && element.frequency?.onceEvery?.unit)
            ? `Frequency: Once Every ${element.frequency?.onceEvery?.value} ${element.frequency?.onceEvery?.unit}`
            : '',
        element?.timing ? `Timing: ${element.timing}` : '',
        element?.duration?.custom
            ? `Duration: ${element.duration.custom}`
            : element?.duration?.value
            ? `Duration: ${element.duration.value}  ${element.duration.unit}`
            : '',
        element?.start_from?.text
            ? `Start From: ${element.start_from.text}`
            : element?.start_from?.value
            ? `Start From: From ${element.start_from.unit} ${element.start_from.value}`
            : '',
        element?.to_day?.text
            ? `To Day: ${element.to_day.text}`
            : element?.to_day?.value
            ? `To Day: To ${element.to_day.unit} ${element.to_day.value}`
            : '',
        element?.quantity?.custom ? `Quantity: ${element?.quantity?.custom}` : '',
        element?.instruction ? `Instruction: ${element.instruction}` : '',
    ].filter(Boolean);

    return properties.join(' | ');
};

export const medicalHistory = (element: MHItem2): string => {
    const properties = [
        buildProperty('Since', (element as MHSince).since?.custom),
        buildProperty('Family Member', (element as FamilyHistory).who),
        buildProperty('Frequency', (element as MHFrequency)?.frequency?.custom),
        getMhDate(element as PastProcedures),
        buildProperty('Remark', element?.notes),
    ].filter(Boolean);

    return properties.join(' | ');
};

export const properties = {
    medicalHistory: medicalHistory,
};

// * utils
const buildProperty = (propertyName: string, custom?: string, value?: string, unit?: string) => {
    if (custom) {
        return `${propertyName}: ${custom}`;
    }

    if (value || unit) {
        return `${propertyName}: ${value ? `${value} ` : ''}${unit ? `${unit} ` : ''}`;
    }

    return '';
};

const getMhDate = (element: PastProcedures) => {
    const { on } = element;

    if (on?.mm || on?.yyyy) {
        return `Date: ${on?.yyyy}/${on?.mm}`;
    }

    return '';
};

export const extractProperties = {
    getMedicationsProperties,
    medicalHistory,
};
